module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "uk-padding"
  }, [_c('ul', {
    staticClass: "uk-breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "uk-align-left"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('table', {
    staticClass: "uk-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.projects), function(p, id) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.convertDate(p.lastEdit)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "uk-link",
      attrs: {
        "to": {
          name: 'ProjectEdit',
          params: {
            id: id
          }
        },
        "uk-icon": "icon: cog"
      }
    })], 1), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "uk-link",
      attrs: {
        "uk-icon": "icon: trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(id)
        }
      }
    })])])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', [_vm._v("Naam")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Tijdstip")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    attrs: {
      "uk-icon": "icon: bolt; ratio: 1.2"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56be405b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/CONTACT/Overview.vue
// module id = 516
// module chunks = 1